import { type FC, type ReactNode, useEffect } from 'react';
import './ModalDialog.scss';

interface Props {
  readonly buttons?: ReactNode;
  readonly cancelColor?: string | undefined;
  readonly cancelText?: string | undefined;
  readonly children?: ReactNode;
  readonly dismiss: () => void;
  readonly mainClassName?: string | undefined;
  readonly titleColor?: string | undefined;
  readonly titleText: string;
}

export const ModalDialog: FC<Props> = ({
  buttons,
  cancelColor,
  cancelText,
  children,
  dismiss,
  mainClassName,
  titleColor,
  titleText,
}: Props) => {
  useEffect(() => {
    const escapeHandler = (event: KeyboardEvent) => {
      if (event.code === 'Escape') {
        dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler, { capture: true });

    return () => {
      document.removeEventListener('keydown', escapeHandler, { capture: true });
    };
  });

  return (
    <div className={`modal is-active`}>
      <div className={'modal-background'} onClick={dismiss} />
      <div className={'modal-card'}>
        <header className={`modal-card-head ${titleColor ? `has-background-${titleColor}-light` : ''}`}>
          <p className={`modal-card-title ${titleColor ? `has-text-${titleColor}-dark` : ''}`}>{titleText}</p>
          <button className={'delete'} aria-label={'close'} onClick={dismiss} />
        </header>
        <main className={`modal-card-body ${mainClassName ?? ''}`}>{children}</main>
        <footer className={'modal-card-foot buttons'}>
          <button className={`button is-${cancelColor ?? 'danger'} is-outlined`} onClick={dismiss}>
            {cancelText ?? 'Cancel'}
          </button>
          {buttons}
        </footer>
      </div>
    </div>
  );
};
ModalDialog.displayName = 'ModelDialog';
